import { cloudWatchLogger } from "./cloudwatch-logger";

export const originalConsole = {
	log: console.log,
	error: console.error,
	warn: console.warn,
	info: console.info,
	debug: console.debug,
};

let isInitialized = false;

export function initializeConsoleOverride() {
	if (isInitialized) {
		return;
	}

	console.log = (...args: unknown[]) => {
		originalConsole.log.apply(console, args);
		cloudWatchLogger.log("log", args);
	};

	console.error = (...args: unknown[]) => {
		originalConsole.error.apply(console, args);
		cloudWatchLogger.log("error", args);
	};

	// Uncomment if needed
	// console.warn = (...args: unknown[]) => {
	// 	originalConsole.warn.apply(console, args);
	// 	cloudWatchLogger.log("warn", args);
	// };

	// console.info = (...args: unknown[]) => {
	// 	originalConsole.info.apply(console, args);
	// 	cloudWatchLogger.log("info", args);
	// };

	// console.debug = (...args: unknown[]) => {
	// 	originalConsole.debug.apply(console, args);
	// 	cloudWatchLogger.log("debug", args);
	// };

	// This is supposed to publish any pending logs to CloudWatch when the page is unloaded but it most likely won't work in most browsers
	window.addEventListener("beforeunload", () => {
		cloudWatchLogger.flush();
	});

	isInitialized = true;
}
